// import { date } from 'joi';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { MdClose, MdFileDownloadDone, MdLocationOn, MdUploadFile } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ProfileTab from '../components/profileTab'
import { addAppointment, getBusinessDetailsForPatients, getBusinessStaffAll, getBusinessStaffDetails, getDetailsForPatients, getStaffTimings } from '../logic/business/action';
import logo from '../images/white_logo.png'
import { IoMdCall } from 'react-icons/io';
import InputComponents from '../components/input';
import { socket } from '../utils/socket';
const SelectDatePortionStaff = () => {
    const params = useParams();
    const [isConnected, setIsConnected] = useState(socket.connected);
    const selector = useSelector((state) => state.business);
    const nav = useNavigate();
    const dispatch = useDispatch();
    const [showError, setshowError] = useState(false);
    const [nameArr, setNameArr] = React.useState([]);
    const [reqObj, setreqObj] = useState({
        staff:params.staffId,
        staff_name:'',
        start_time:'',
        end_time:'',
        service:0,
        // dateS:
        date:`${new Date().getFullYear()}-${(new Date().getMonth()+1)>9?(new Date().getMonth()+1):`0${(new Date().getMonth()+1)}`}-${new Date().getDate()>9?new Date().getDate():`0${new Date().getDate()}`}`
    });
    console.log(reqObj.date);
    const [dragActive, setDragActive] = React.useState(false);
    const [error, seterror] = useState('');
    const [dragFile, setDragFile] = React.useState([]);
  
  // handle drag events
  const handleDrag = function(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log(e.type);
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e)=> {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    // console.log(e);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        // alert('hi');
        const dt = [];
        for (const iterator of e.dataTransfer.files) {
          dt.push(iterator.name);
        }
      setDragFile((prev=>[...prev,...e.dataTransfer.files]));
      setNameArr((prev=>[...prev,...dt]));
    }
  };

  const handleChange = (e)=> {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
        const dt = [];
        for (const iterator of e.target.files) {
          dt.push(iterator.name);
        }
      setDragFile((prev=>[...prev,...e.target.files]));
      setNameArr((prev=>[...prev,...dt]));
        // setDragFile(e.target.files[0]);
    }
  };
  const onConnect = () =>{
    setIsConnected(true);
  }
  const onDisconnect = () =>{
    setIsConnected(false);
  }
    useEffect(() => {
        // getBilling(dispatch);

        const id = params.id.split('_');
        if(id.length > 1 && !isNaN(parseInt(id[id.length - 1]))){
            getBusinessDetailsForPatients(dispatch, parseInt(id[id.length - 1]));
        }
        getDetailsForPatients(dispatch, params.customerId);
        getBusinessStaffDetails(dispatch, params.staffId);
        if(!isConnected){
            socket.connect();
          }
      socket.on('connect', onConnect);
      socket.on('disconnect', onDisconnect);
          return () => {
      socket.disconnect();
            socket.off('connect', onConnect);
            socket.off('disconnect', onDisconnect);
          };
      }, []);

      useEffect(()=>{
        if(reqObj.service !==0 && reqObj.date !== ''){
            
            const id = params.id.split('_');
            if(id.length > 1 && !isNaN(parseInt(id[id.length - 1]))){
            getStaffTimings(dispatch,params.staffId,parseInt(id[id.length - 1]),reqObj.date);
        }
        }
      },[reqObj.service,reqObj.date])
  return (
    <div className='w-screen h-screen bg-blue-700 overflow-y-scroll'>
        {/* <div className='h-2'></div> */}
        <div className='w-full flex mt-6 justify-center items-center'>
          {
            selector?.details?.url!=null && selector?.details?.url!=='' ?
              <img src={selector?.details?.url} alt="" width={'100px'} className=''/>
              :
              <img src={logo} alt="" width={'100px'} height={'100px'} className=''/>
          }
        </div>
   <div className='w-full p-4 lg:px-10 lg:py-4 bg-blue-700 text-center'>
                <h4 className='text-white font-bold text-xl uppercase'>Welcome {selector?.detailsCustomer?.full_name}</h4>
        </div>
        {/* <div className='h-2'></div> */}
        {
          params?.id != null && params?.id !== undefined &&  selector?.details != null ?
          <div className='w-full flex flex-col gap-4 items-center rounded-t-3xl bg-white min-h-screen'>
        {/* <h2 className='text-blue-700 font-semibold text-lg text-center pt-4'>Fill the details below to Book Appointment</h2> */}
        
        <div className='w-full p-4 lg:p-10 flex items-center flex-wrap gap-4'>
        {/* <div className='w-full lg:w-[48%] flex flex-col items-start'>
        <ProfileTab isEdit={false} name='Business Name' value={selector?.details?.name}/>
        <ProfileTab isEdit={false} name='Business Contact' value={`+91-${selector?.details?.contact}`}/>
        <ProfileTab isEdit={false} name='Business Email' value={selector?.details?.email}/>
        <ProfileTab isEdit={false} name='Business Address' value={selector?.details?.address}/>
        </div> */}
        <div className='w-full lg:w-[48%] mx-auto flex flex-col items-center p-4 rounded-lg bg-white gap-4'>
            <h2 className='text-blue-700 font-bold text-2xl text-center'>Book your Appointment with <br/> {selector?.details?.name} ({selector?.staffDetails?.name})</h2>
            {/* <h2 className='text-blue-700 font-bold text-2xl text-center'>Book your Appointment with staff <br/> {selector?.staffDetails?.name}</h2> */}
            <div className='h-4'></div>
            {/* <input type="text" placeholder='Your Full Name*' /> */}
           <div className='w-full'>
            <label htmlFor="services">Select Service *</label>
            <select name="services" id="services" value={reqObj.service} 
            onClick={()=>setshowError(true)}
            onChange={(ev)=>{
                setreqObj((prev)=>({...prev,staff:0,service:parseInt(ev.target.value)}));
               const id = params.id.split('_');
                getBusinessStaffAll(
                    dispatch,parseInt(id[id.length - 1]),ev.target.value
                    )
                }}>
                <option value={0}>Select from here</option>
                {
                    selector?.services?.filter(el=>selector.staffDetails?.services?.includes(String(el.service_id)))?.map((e,i)=><option value={e?.service_id}>{e?.service}</option>)
                }
            </select>
            {
                showError && reqObj.service === 0?
                <p className='text-red-500'>Please select service</p>:''
            }
                </div>
            {/* <div> */}
                {/* <div className='w-full'>
            <label htmlFor="staff">Select Staff *</label>
            {
                selector?.staff?.length>0?
            <select name="staff" id="staff" value={reqObj.staff} 
            onClick={()=>setshowError(true)} onChange={(ev)=>{
                setreqObj((prev)=>({...prev,staff:parseInt(ev.target.value),staff_name:selector?.staff?.find(el=>el.staff_id===parseInt(ev.target.value)).name}));
            }}>
                <option value={0}>Select from here</option>
                {
                    selector?.staff?.map((e,i)=><option value={e?.staff_id}>{e?.name}</option>)
                }
            </select>
                
                :<div className='animate-pulse bg-gray-200 w-full h-10 rounded-md'></div>
            }
            {
                showError && reqObj.staff===0?
                <p className='text-red-500'>Please select staff</p>:''
            }
                </div> */}
            
            <div className='w-full'>
            <label htmlFor="date">Select Date *</label>
            <div className='flex w-full gap-2'>
            <input type="date" 
        defaultValue={new Date().toLocaleDateString("en-IN")} value={reqObj.date} onChange={(ev)=>setreqObj(prev=>({...prev,date:ev.target.value}))} placeholder='Date' />
            </div>
            </div>
            <div className='w-full'>
            <label htmlFor="slot">Select Slot *</label>
            {
                // selector?.timingsFull?.length > 0?
            <select name="slot" id="slot" 
            onClick={()=>setshowError(true)} value={reqObj.start_time} onChange={(ev)=>{
                setreqObj(prev=>({...prev,start_time:ev.target.value,end_time:selector?.timingsFull?.find(el=>el.start_time===ev.target.value).end_time}));
            }}>
                <option value={''}>Select from here</option>
                {
                    selector?.timingsFull?.length > 0?
                    selector?.timingsFull?.filter((el)=>!el.booked).map((el)=><option value={el.start_time}>{moment(el.start_time, "HH:mm:ss").format("hh:mm A")} - {moment(el.end_time, "HH:mm:ss").format("hh:mm A")}</option>):
                    <option value={' '} disabled>
                        {
                            selector.loading ?'Loading...':'No slots'
                        }
                        </option>
                }
            </select>
                
                // :<div className='animate-pulse bg-gray-200 w-full h-10 rounded-md'></div>
            }
            {
                showError && reqObj.start_time===''?
                <p className='text-red-500'>Please select slot</p>:''
            }
                </div>
            
{
            selector.error?
            <p className='text-red-500'>{selector.errorMessage}</p>:''
}
        {
            (selector?.details && selector?.details?.storage_limit &&selector?.details?.storage_limit>0) ?
<form className={`w-full h-40 relative ${dragActive?'bg-gray-200':''}`} id="form-file-upload" onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
            <input type={'file'} className={'hidden'} name='file' id='file' onChange={handleChange} multiple={true}/>
            <label className='w-full' htmlFor="file">
            <div className='w-full h-full border-dashed border border-gray-400 rounded-md p-10 flex items-center flex-col'>
                `   <MdUploadFile size={50} color={'#0B469D'}/>
                <p className='flex gap-2 items-center'>
                    <p className='highlited'>Click to upload</p>
                    <span>or drag and drop your documents here</span>
                </p>
            </div>
            </label>
      { dragActive && <div className="absolute w-full z-10 h-full top-0 right-0" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div> }
            </form> : null
        }  
            {
                dragFile && dragFile?.map((e,i)=>
                <div className='w-full flex items-center gap-4 border border-[#0B469D] rounded-md p-4'>
                <div className='flex justify-center items-center p-4 border border-gray-300 rounded-sm'>
                    <MdFileDownloadDone/>
                </div>
                <InputComponents
                label={'Name'}
                name={'doc_name_'+i}
                value={nameArr[i]}
                onChange={(el)=>{
                    let tempArr = [...nameArr];
                    console.log(tempArr);
                    tempArr[i] = el.target.value;
                    setNameArr(tempArr);                  
                }}
                />
                <div className='flex-1'></div>
                <MdClose onClick={()=>{
                    setDragFile(prev=>prev.filter(el=>el.name!==e.name));
                    setNameArr(prev=>prev.filter(el=>el !== nameArr[i]));
                }} className='cursor-pointer'/>
                </div>
                )
            }
            <p className='text-red-600'>{error}</p>
            <button 
            disabled={selector.loadingBook || reqObj.start_time ==='' || reqObj.date==='' || reqObj.service===0}
            className="disabled:bg-gray-500 w-full mt-4"
            onClick={()=>{

            const id = params.id.split('_');
            if(id.length > 1 && !isNaN(parseInt(id[id.length - 1]))){
                addAppointment(dispatch,parseInt(id[id.length - 1]),params.customerId,{...reqObj, staff: params.staffId},nav,selector.staffDetails.fcm,dragFile,seterror,nameArr,socket,selector?.details?.fcm,params.id);
            }
            }}>Proceed</button>
        </div>
        {/* <hr className='w-full border'/>
            <div className='flex flex-col items-center gap-2 w-full'>
            <h4 className='text-blue-600 font-bold w-full text-center text-lg'>{selector?.details?.name}</h4>
            <div>
            <div className='flex items-center gap-4' ><MdLocationOn size={24} /> {selector?.details?.address}</div>
            <div className='flex items-center gap-4' ><IoMdCall size={24} /> {selector?.details?.contact}</div>
            </div>
            </div> */}
            {/* <div className='h-40'></div> */}
        <div className='bg-[#0B469D] rounded-t-xl w-full fixed bottom-0 left-0 text-white text-center p-2'>
            @theappointmentapp
        </div>
        </div>
        </div>:''
        }
    </div>
  )
}

export default SelectDatePortionStaff;